import Wizard from './Wizard';
import WizardBody from './WizardBody';
import WizardContents from './WizardContents';
import WizardFooter from './WizardFooter';
import WizardHeader from './WizardHeader';
import WizardMain from './WizardMain';
import WizardReviewContent from './WizardReviewContent';
import WizardReviewItem from './WizardReviewItem';
import WizardReviewStep from './WizardReviewStep';
import WizardReviewSteps from './WizardReviewSteps';
import WizardReviewSubStep from './WizardReviewSubStep';
import WizardReviewSubSteps from './WizardReviewSubSteps';
import WizardRow from './WizardRow';
import WizardSidebar from './WizardSidebar';
import WizardSidebarGroup from './WizardSidebarGroup';
import WizardSidebarGroupItem from './WizardSidebarGroupItem';
import WizardStep from './WizardStep';
import WizardSteps from './WizardSteps';
import WizardSubStep from './WizardSubStep';

import WizardPattern from './Patterns/WizardPattern';
import WizardPatternBody from './Patterns/WizardPatternBody';
import StatefulWizardPattern from './Patterns/StatefulWizardPattern';

Wizard.Body = WizardBody;
Wizard.Contents = WizardContents;
Wizard.Footer = WizardFooter;
Wizard.Header = WizardHeader;
Wizard.Main = WizardMain;
Wizard.ReviewContent = WizardReviewContent;
Wizard.ReviewItem = WizardReviewItem;
Wizard.ReviewStep = WizardReviewStep;
Wizard.ReviewSteps = WizardReviewSteps;
Wizard.ReviewSubStep = WizardReviewSubStep;
Wizard.ReviewSubSteps = WizardReviewSubSteps;
Wizard.Row = WizardRow;
Wizard.Sidebar = WizardSidebar;
Wizard.SidebarGroup = WizardSidebarGroup;
Wizard.SidebarGroupItem = WizardSidebarGroupItem;
Wizard.Step = WizardStep;
Wizard.Steps = WizardSteps;
Wizard.SubStep = WizardSubStep;

Wizard.Pattern = WizardPattern;
Wizard.Pattern.Body = WizardPatternBody;
Wizard.Pattern.Stateful = StatefulWizardPattern;

export { Wizard, WizardBody, WizardContents, WizardFooter, WizardHeader, WizardMain, WizardReviewContent, WizardReviewItem, WizardReviewStep, WizardReviewSteps, WizardReviewSubStep, WizardReviewSubSteps, WizardRow, WizardSidebar, WizardSidebarGroup, WizardSidebarGroupItem, WizardStep, WizardSteps, WizardSubStep, WizardPattern, WizardPatternBody, StatefulWizardPattern };


//////////////////
// WEBPACK FOOTER
// ./node_modules/patternfly-react/dist/esm/components/Wizard/index.js
// module id = 936
// module chunks = 0